export function getUserActivitiesUserId(additional: unknown): string {
  if (typeof additional === 'string') {
    return additional;
  }

  if (additional && typeof additional === 'object' && 'userId' in additional) {
    const userId = (additional as { userId?: unknown }).userId;
    return typeof userId === 'string' ? userId : '';
  }

  return '';
}
